import { Heart, Users, ShieldCheck } from "lucide-react";
import { useUiTranslations } from "@/hooks/use-ui-translations";

const icons = [Heart, Users, ShieldCheck];

export function BrandValues() {
  const { t } = useUiTranslations();

  const values = [
    { icon: icons[0], heading: t("brandValues.0.heading"), body: t("brandValues.0.body") },
    { icon: icons[1], heading: t("brandValues.1.heading"), body: t("brandValues.1.body") },
    { icon: icons[2], heading: t("brandValues.2.heading"), body: t("brandValues.2.body") },
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4">
        <div className="grid gap-10 sm:grid-cols-3 sm:gap-8">
          {values.map((v) => (
            <div key={v.heading} className="text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-teal-brand/10">
                <v.icon className="h-5 w-5 text-teal-brand" />
              </div>
              <h3 className="text-sm font-semibold tracking-wide text-foreground">
                {v.heading}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {v.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
